// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"0a9d45b0","513":"1ac10db2","703":"678be06b"}[chunkId] + ".chunk.js";
};